import { LiveOpsClientEventName, MAX_CONNECTION_DURATION_MS } from '@playcastdotio/Messaging';
import type { IQuickstartLiveOpsManager } from './IQuickstartLiveOpsManager';
import type { ILiveOpsTransport } from './liveOpsTransport';

export class QuickstartLiveOpsManager implements IQuickstartLiveOpsManager {
  private readonly transport: ILiveOpsTransport;

  constructor(transport: ILiveOpsTransport) {
    this.transport = transport;
  }

  emitPageLoaded(): void {
    this.transport.sendEvent({
      eventName: LiveOpsClientEventName.PAGE_LOADED,
      occurredAt: Date.now(),
    });
  }

  emitStreamRendered(connectionDurationMs?: number): void {
    // Clamp to the contract's sanity range. The inbound schema REJECTS the whole
    // message if connectionDurationMs exceeds MAX_CONNECTION_DURATION_MS, so an
    // otherwise-valid long-lived session (stream rendered >10min after page load)
    // would silently lose its stream_rendered funnel milestone. Clamping keeps
    // the conversion signal while capping the (secondary) duration metric.
    const clampedDurationMs =
      connectionDurationMs !== undefined
        ? Math.min(Math.max(connectionDurationMs, 0), MAX_CONNECTION_DURATION_MS)
        : undefined;

    this.transport.sendEvent({
      eventName: LiveOpsClientEventName.STREAM_RENDERED,
      occurredAt: Date.now(),
      ...(clampedDurationMs !== undefined ? { connectionDurationMs: clampedDurationMs } : {}),
    });
  }

  emitFirstInput(): void {
    this.transport.sendEvent({
      eventName: LiveOpsClientEventName.FIRST_INPUT,
      occurredAt: Date.now(),
    });
  }
}
